'use client'

import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async';
import Header from './LandingPage/Layout/Header'
import HeroSection from './LandingPage/Sections/HeroSection'
import PainPointsSection from './LandingPage/Sections/PainPointsSection'
import HowItWorksSection from './LandingPage/Sections/HowItWorksSection'
import AdvantageSection from './LandingPage/Sections/AdvantageSection'
import PricingSection from './LandingPage/Sections/PricingSection'
import FAQSection from './LandingPage/Sections/FAQSection'
import CTABanner from './LandingPage/Sections/CTABanner'
import Footer from './LandingPage/Layout/Footer'
import WhatsAppButton from './LandingPage/UI/WhatsAppButton'

export default function Home() {
  // Optional: Add smooth scrolling for anchor links
  useEffect(() => {
    const handleAnchorClick = (e) => {
      const targetId = e.target.getAttribute('href');
      if (targetId && targetId.startsWith('#')) {
        e.preventDefault();
        const targetElement = document.getElementById(targetId.substring(1));
        if (targetElement) {
          window.scrollTo({
            top: targetElement.offsetTop - 100, // Offset for fixed header
            behavior: 'smooth'
          });
        }
      }
    };

    // Add event listeners to all anchor links
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach(link => {
      link.addEventListener('click', handleAnchorClick);
    });

    // Cleanup
    return () => {
      links.forEach(link => {
        link.removeEventListener('click', handleAnchorClick);
      });
    };
  }, []);

  return (
    <div className="bg-background-50">

      <Helmet>
        <title>ScanMaadi | Turn Paper Menus into Smart QR Menus for Restaurants & Cafes in India</title>
        <meta name="description" content="Digitize your restaurant menu with ScanMaadi — India's easiest way to create searchable, filterable QR code menus. No app needed. Instant setup." />
        <meta property="og:title" content="ScanMaadi | Smart QR Menus for Indian Restaurants" />
        <meta property="og:description" content="No more paper menus! ScanMaadi turns photos of your menu into digital, searchable QR code menus. Perfect for small eateries & cafes." />
        <meta property="og:image" content="https://scanmaadi.com/og-image.png" />
        <meta property="og:url" content="https://scanmaadi.com" />
        <meta property="og:type" content="website" />

      </Helmet>
      {/* Header */}
      <Header />

      {/* Main content sections */}
      <main>
        <HeroSection />
        <PainPointsSection />
        <HowItWorksSection />
        <AdvantageSection />
        <PricingSection />
        <FAQSection />
        <CTABanner />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating WhatsApp button */}
      <WhatsAppButton />
    </div>
  )
}